module.exports = __webpack_public_path__ + "img/plants.47b7ca2a.svg";